import React, { Component } from 'react';
import { Col, /*Row,*/ Form } from 'react-bootstrap';
import RoleUtils from '../utils/roleUtils.js';
import '../styles/PopUps.css';

export class TableRoleDisplay extends Component {
    noOp() {
    }
    array_move(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr; 
    };


    buildRoleDisplay(roles, showInactive) {
        //DE1065226 - Always show disabled role as enabled in the UI - A user either has the role or does not
        var hasDisabledAccount = roles.some(r => r.roleId === 7);
        //US7652820 - Disable Roles if user has locked account
        var hasLockedAccount = roles.some(r => r.roleId === 6);
        //Filter out INACTIVE roles if showInactiveRoles prop is false
        var userRoles = (showInactive) ? roles: roles.filter(r => r.roleId !== 6 && r.roleId !== 7);
        //Sort with SPUA on top   
        userRoles.sort((a, b) => a.description.localeCompare(b.description));
        //Only put SPUA on top if user is not InActive
        if (!hasLockedAccount) {
            var spuaIdx = userRoles.findIndex(r => r.roleId === 3);
            if (spuaIdx > -1) {
                roles = this.array_move(userRoles, spuaIdx, 0);
             }
        }
        return (
            userRoles.map((role, idx) => {
                return (<Col xs={12} className="tblRoleItem" key={idx}>
                    <Form.Check type="checkbox">
                        <Form.Check.Input
                            type="checkbox"
                            disabled={(role.enabled == false || hasLockedAccount || hasDisabledAccount)}
                            checked={role.enabled || hasDisabledAccount}
                            className="userStatusOption"
                            onChange={this.noOp}
                            title="role"
                         />
                        <Form.Check.Label>{role.roleId ? RoleUtils.roleIntToName(role.roleId) : role.description}</Form.Check.Label>  
                    </Form.Check></Col>);

            })
        );
    }

    render() {
        const { roles,showInactiveRoles } = this.props;
        var showInactive = (showInactiveRoles === undefined) ? false : showInactiveRoles;
        const display = this.buildRoleDisplay(roles, showInactive);
        return (
            <div className="multiRoleArea">
                { display}
            </div>
 
        );  
       
  }
}
